import { Button, ButtonProps } from "@mui/material";
import { ContainedButtonProps } from "./contained.type";
import styles from "./contained.style";

const ContainedButton = ({
  title,
  externalStyles,
  primary = false,
  ...otherProps
}: ContainedButtonProps & ButtonProps) => {
  return (
    <Button
      variant="contained"
      className="loginBtn"
      sx={
        primary
          ? { ...styles.btnPrimary, ...externalStyles }
          : { ...styles.btnNormal, ...externalStyles }
      }
      {...otherProps}
    >
      {title}
    </Button>
  );
};

export default ContainedButton;
